import { lazyLoad } from 'utils/loadable';

export const SelectTemplateForContact = lazyLoad(
  () => import('./index'),
  module => module.SelectTemplateForContact,
);
